import React, { forwardRef } from 'react';

interface DropDownProps {
  options: { id: string; name: string }[];
  disabled?: boolean;
  name?: string;
  defaultValue?: string;
  className?: string;
  value?: Function
}

const DropDown = forwardRef<HTMLSelectElement, DropDownProps>(({ options, disabled = false, name, defaultValue, className, value}, ref) => {
  return (
    <select
      id={name}
      disabled={disabled}
      name={name}
      data-name="Field 3"
      className={className}
      ref={ref}
      onChange={(e) => value && value(Number(e.target.value))}
    >
      {options && options.map((option) => (
        <option selected={defaultValue === option.id ?true:false} key={option.name+option.id} value={option.id}>
          {option.name}
        </option>
      ))}
    </select>
  );
});

export default DropDown;